import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const GetOrganisationSettingsDetailsDocument = gql`
  query GetOrganisationSettingsDetails($organisationId: Int!) {
    organisation(id: $organisationId) {
      id
      name
      isAPurchaser
      parent {
        id
        name
      }
      billingAddressCountry
      createdAt
      owner {
        id
        name
      }
      isVerified
      legalEntity
      businessName
      businessNumber
      billingAddressLine1
      billingAddressLine2
      billingAddressCity
      billingAddressStateProvince
      billingAddressPostalCode
      postalAddressLine1
      postalAddressLine2
      postalAddressCity
      postalAddressStateProvince
      postalAddressPostalCode
    }
  }
` as unknown as DocumentNode<
  Types.GetOrganisationSettingsDetailsQuery,
  Types.GetOrganisationSettingsDetailsQueryVariables
>
